import { news } from '../../../mocks/news';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';

export default function News() {
  useEffect(() => {
    // Load Instagram embed script
    const script = document.createElement('script');
    script.src = '//www.instagram.com/embed.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <section id="news" className="bg-gradient-to-b from-[#1a1a1a] to-[#0d0d0d] py-24 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-6xl font-bold text-white mb-4">LATEST NEWS</h2>
          <p className="text-xl text-gray-500">Stay Updated on Nightmare's Journey</p>
        </div>

        {/* News Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {news.map((article) => {
            const CardWrapper = article.externalLink ? 'a' : 'div';
            const wrapperProps = article.externalLink 
              ? { href: article.externalLink, target: '_blank', rel: 'noopener noreferrer' }
              : {};

            return (
              <CardWrapper
                key={article.id}
                {...wrapperProps}
                className="group bg-[#141414] rounded-lg overflow-hidden hover:transform hover:-translate-y-2 transition-all duration-300 hover:shadow-2xl hover:shadow-red-950/30 border border-gray-800 hover:border-gray-700 cursor-pointer"
              >
                {/* Image or Video */}
                <div className="relative h-56 w-full overflow-hidden bg-black flex items-center justify-center">
                  {article.videoEmbed && article.thumbnail ? (
                    <div className="relative w-full h-full group/video">
                      <img
                        src={article.thumbnail}
                        alt={article.title}
                        className="w-full h-full object-cover"
                      />
                      {/* Play Button Overlay */}
                      <div className="absolute inset-0 flex items-center justify-center bg-black/30 group-hover/video:bg-black/40 transition-colors">
                        <div className="w-16 h-16 flex items-center justify-center bg-red-600 rounded-full group-hover/video:bg-red-700 transition-colors">
                          <i className="ri-play-fill text-white text-3xl ml-1"></i>
                        </div>
                      </div>
                    </div>
                  ) : article.videoEmbed ? (
                    <iframe
                      src={article.videoEmbed}
                      className="w-full h-full"
                      frameBorder="0"
                      allowFullScreen
                      allow="fullscreen"
                    />
                  ) : article.instagramEmbed && article.thumbnail ? (
                    <div className="relative w-full h-full group/instagram">
                      <img
                        src={article.thumbnail}
                        alt={article.title}
                        className="w-full h-full object-cover"
                      />
                      {/* Instagram Icon Overlay */}
                      <div className="absolute inset-0 flex items-center justify-center bg-black/30 group-hover/instagram:bg-black/40 transition-colors">
                        <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-purple-600 via-pink-600 to-orange-500 rounded-full group-hover/instagram:scale-110 transition-transform">
                          <i className="ri-instagram-fill text-white text-3xl"></i>
                        </div>
                      </div>
                    </div>
                  ) : article.instagramEmbed ? (
                    <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-purple-600 via-pink-600 to-orange-500 p-1">
                      <div className="w-full h-full bg-black flex items-center justify-center">
                        <i className="ri-instagram-fill text-white text-6xl"></i>
                      </div>
                    </div>
                  ) : (
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-contain object-center group-hover:scale-110 transition-transform duration-500"
                    />
                  )}
                </div>

                {/* Content */}
                <div className="p-8">
                  <p className="text-gray-600 text-xs uppercase tracking-wider mb-3">
                    {article.date}
                  </p>
                  <h3 className="text-white text-2xl font-bold mb-4 line-clamp-2 leading-tight">
                    {article.title}
                  </h3>
                  <p className="text-gray-500 text-base leading-relaxed mb-6 line-clamp-3">
                    {article.excerpt}
                  </p>
                  {article.externalLink ? (
                    <span className="inline-flex items-center space-x-2 text-[#8B0000] font-semibold hover:text-[#6B0000] transition-colors group/link">
                      <span>READ MORE</span>
                      <i className="ri-arrow-right-line group-hover/link:translate-x-1 transition-transform"></i>
                    </span>
                  ) : (
                    <Link
                      to={`/article/${article.id}`}
                      className="inline-flex items-center space-x-2 text-[#8B0000] font-semibold hover:text-[#6B0000] transition-colors group/link"
                    >
                      <span>READ MORE</span>
                      <i className="ri-arrow-right-line group-hover/link:translate-x-1 transition-transform"></i>
                    </Link>
                  )}
                </div>
              </CardWrapper>
            );
          })}
        </div>
      </div>
    </section>
  );
}
